import {findMany} from '../helpers';

const elements = findMany('oembed[url]') || [];

if (elements.length) {
    import('./index');
}
